var React = require('react');

function Blob3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"a","d":"M1080,51.372H201.127c-135.133,0-131.47,163.363,0,163.363H878.873c135.133,0,131.47,163.363,0,163.363H201.127c-135.133,0-131.47,163.363,0,163.363H878.873c135.133,0,131.47,163.363,0,163.363H201.127c-135.133,0-131.47,163.363,0,163.363H878.873c135.133,0,131.47,163.363,0,163.363H0"}));
}

Blob3.defaultProps = {"viewBox":"0 0 1080 1082.922"};

module.exports = Blob3;

Blob3.default = Blob3;
